package game.entity

import com.soywiz.korui.layout.MathEx.max
import game.Game
import game.Room
import game.Weapon

open class Enemy(var hp: Int = 1, var damage: Int = 1, var onDeath: (Enemy) -> Unit = {}) : Entity() {
    override fun onCollideWithPlayer(game: Game, room: Room): Boolean {
        game.player.takeDamage(damage)

        return true
    }

    override fun onAttacked(game: Game, weapon: Weapon) {
        takeDamage(game, weapon.damage)
    }


    fun takeDamage(game: Game, damage: Int) {
        if (damageCoolDown == 0) {
            hp = max(0, hp - damage)

            if (hp == 0) {
                onDeath.invoke(this)
                killMe(game)
            } else {
                game.playSound("enemy-hit")
            }

            damageCoolDown = 100
        }
    }
}